module.exports = __webpack_public_path__ + "img/serviceImg1.c77594ff.gif";